module.exports = __webpack_public_path__ + "media/images/flags/32/Armenia-e6915a84287bbbf5075701bd4b816d13.png";